import { useMemo, useCallback } from 'react'

export default function useOthersOnThisRecord(
  currentPersonRecord,
  relationships,
  currentImageArk,
  thumbnails,
  selectedPersonId
) {
  const assemblePages = useCallback(
    (persons) => {
      const pages = []
      persons.forEach((person) => {
        const pagesEntry = pages.find((p) => p.partitionKey === person.partitionKey)
        if (!pagesEntry) {
          pages.push({
            partitionKey: person.partitionKey,
            pageNumber: (thumbnails?.findIndex((thumbnail) => thumbnail.ark === person.partitionKey) || 0) + 1,
            persons: [person],
          })
        } else {
          pagesEntry.persons.push(person)
        }
      })
      return pages
    },
    [thumbnails]
  )

  return useMemo(() => {
    const persons =
      currentPersonRecord?.subElements?.filter(
        (se) =>
          se.elementType === 'PERSON' &&
          !relationships.find((relField) => relField.otherPersonId === se.id) &&
          se.id !== selectedPersonId
      ) || []
    const pages = assemblePages(persons)
    // Sort pages with names on current page at top and the rest proceeding in page order
    const currentPageIx = pages.findIndex((page) => page.partitionKey === currentImageArk)
    let currentPage
    if (currentPageIx !== -1) {
      currentPage = pages[currentPageIx]
      pages.splice(currentPageIx, 1)
    }
    pages.sort((a, b) => {
      if (a.partitionKey === currentImageArk) return 1
      return a.pageNumber - b.pageNumber
    })
    if (currentPage) {
      pages.unshift(currentPage)
    }
    return pages
  }, [currentPersonRecord?.subElements, assemblePages, relationships, selectedPersonId, currentImageArk])
}
